import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

export interface iCheckUserListState {
    isLoading : boolean;
    response : any;
}

const initialState :iCheckUserListState = {
    isLoading :false,
    response : []
}

export const getCheckUserListAPI = createAsyncThunk(
    'GET_USER_LIST',
    async(_,{rejectWithValue}) =>{
        // 장고 API 주소
        const djangoEndpoint = getDjangoEndpoint();
        const pathParam = '/auth/list-users/'

        try{

            const response = await axios.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials:true,
            })
            return response.data;
        }catch(error){
            return rejectWithValue(error.response ? error.response.data : error.message);
        }

    }
)

export const checkUserSlice = createSlice({
    name: "checkAdminList",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getCheckUserListAPI.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getCheckUserListAPI.fulfilled, (state, action) => {
            state.isLoading = false; 
            state.response = action.payload; 
        })
        .addCase(getCheckUserListAPI.rejected, (state) => {
            state.isLoading = false; 
        });
    }
});

export default checkUserSlice.reducer;